const DISMISS_KEY = "circa.a2hs.dismissed";

/** True when running as an installed PWA / home-screen web app. */
export function isStandaloneDisplay() {
  if (typeof window === "undefined") return false;
  try {
    if (window.matchMedia?.("(display-mode: standalone)")?.matches) return true;
    if (window.matchMedia?.("(display-mode: fullscreen)")?.matches) return true;
    // iOS Safari
    if (window.navigator?.standalone === true) return true;
  } catch {
    /* ignore */
  }
  return false;
}

export function isA2hsDismissed() {
  try {
    return localStorage.getItem(DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissA2hs() {
  try {
    localStorage.setItem(DISMISS_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function clearA2hsDismiss() {
  try {
    localStorage.removeItem(DISMISS_KEY);
  } catch {
    /* ignore */
  }
}

/** Rough platform hint for install instructions. */
export function getA2hsPlatform() {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "other";
}

let deferredPrompt = null;
let listening = false;

/** Capture Android Chrome beforeinstallprompt once at app load. */
export function listenForInstallPrompt() {
  if (listening || typeof window === "undefined") return;
  listening = true;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
  });
}

export function getDeferredInstallPrompt() {
  return deferredPrompt;
}

export async function promptInstall() {
  const promptEvent = deferredPrompt;
  if (!promptEvent) return { outcome: "unavailable" };
  deferredPrompt = null;
  promptEvent.prompt();
  const choice = await promptEvent.userChoice;
  return { outcome: choice?.outcome || "dismissed" };
}

/** Show the inbox banner: not standalone, not dismissed, on a phone-sized viewport. */
export function shouldShowA2hsBanner({ isMobile = false } = {}) {
  if (!isMobile) return false;
  if (isStandaloneDisplay()) return false;
  if (isA2hsDismissed()) return false;
  return true;
}
